import posthog from 'posthog-js';
const key = import.meta.env.VITE_POSTHOG_KEY ?? 'phc_p7H6irzWywUp3bYUEN5meJMsySkw0MJjkmWtxdfZ2Yg';
const host = import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com';
if (key) {
    posthog.init(key, {
        api_host: host,
        person_profiles: 'identified_only',
        capture_pageview: 'history_change',
        capture_pageleave: true,
    });
}
export { posthog };
